import type { IconNode } from '../types';

/**
 * @name yin-yang
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjciIHI9Ii41IiAvPgogIDxwYXRoIGQ9Ik0xMiAyMmE1IDUgMCAxIDAgMC0xMCA1IDUgMCAxIDEgMC0xMCIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjE3IiByPSIuNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/yin-yang
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const yinYang: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['circle', { cx: '12', cy: '7', r: '.5', key: 'mkwsql' }],
  ['path', { d: 'M12 22a5 5 0 1 0 0-10 5 5 0 1 1 0-10', key: '13i4wz' }],
  ['circle', { cx: '12', cy: '17', r: '.5', key: '1wuz4s' }],
];

export default yinYang;
